import { Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { intlFormatDateShort } from "src/utils/time-utils";
import { DocumentDTO } from "../../../models/documents";
import { TransactionDTO, TransactionRef } from "../../../models/transactions";
import LinkEntity from "../../LinkEntity/LinkEntity";
import { Item, ResetButtonContainer, SelectedBlock } from "./styles";

interface Props {
  transaction: TransactionDTO;
  documentToLink: DocumentDTO | null;
  handleChangeDocumentToLink: ((document: DocumentDTO | null) => void) | undefined;
  customNameForDocToLink?: string;
  forceClose?: () => void;
  handleNotifyParent?: () => void;
}

export const LinkExistingDocument = ({
  transaction,
  documentToLink,
  handleChangeDocumentToLink,
  customNameForDocToLink,
  forceClose,
  handleNotifyParent,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "components.link_entity"; // tRP - translation root path

  const handleResetLinkedDocument = () => {
    handleChangeDocumentToLink && handleChangeDocumentToLink(null);
  };

  return (
    <>
      <LinkEntity
        linkedEntity={transaction as TransactionRef}
        entityToLinkName="document"
        linkedEntityName="transaction"
        handleChangeDocumentToLink={handleChangeDocumentToLink}
        documentToLink={documentToLink}
        legalEntitiesIds={[...(transaction?.legalEntity?.id ? [transaction.legalEntity?.id] : [])]}
        withoutTransactions={true}
        transactionTypeId={transaction?.type?.id}
        customNameForDocToLink={customNameForDocToLink}
        shouldClose={forceClose}
        handleNotifyParent={handleNotifyParent}
      />
      {documentToLink && (
        <SelectedBlock>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold" }}
          >
            {`${t(`${tRP}.selected_item`)}`}
          </Typography>

          <>
            <Item>
              <span>{`${t(`${tRP}.date_column`)}`}</span>
              <span>{`${t(`${tRP}.description_column`)}`}</span>
              <span>{`${t(`${tRP}.status_column`)}`}</span>
            </Item>

            <Item selected={true}>
              <span>{intlFormatDateShort(documentToLink?.createdAt)}</span>
              <span>{documentToLink?.name ?? documentToLink?.type?.name ?? ""}</span>
              <span>{documentToLink?.status?.name}</span>
            </Item>
          </>
          <ResetButtonContainer>
            <Button
              variant="outlined"
              color="error"
              onClick={handleResetLinkedDocument}
            >
              {t(`buttons.reset`)}
            </Button>
          </ResetButtonContainer>
        </SelectedBlock>
      )}
    </>
  );
};
